// extracted by mini-css-extract-plugin
export default {"quoteBackground":"quoteBackground___Y3_Z0","quoteText":"quoteText___YXSiD","quoteAttribution":"quoteAttribution___n0TX3"};